module.exports = __webpack_public_path__ + "static/img/服务小程序.561e627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/服务小程序.png
// module id = esSg
// module chunks = 58